import React, { Component } from "react";
import Badge from "react-bootstrap/Badge";
import firebase from "./firebase";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoUrl: "",
      logoName: "",
      facebookUrl: "",
      instagramUrl: ""
    };
    this.getLogo();
  }
  render() {
    return (
      <div align="center" style={{ height: "40px" }}>
        <h6 variant="secondary">Copyright © Cockatoo 2019</h6>
        <a href={this.state.instagramUrl}>
          <img
            src="\images\icon_instagram.png"
            width="30"
            height="30"
            className="d-inline-block "
            alt="Instagram"
            style={{ margin: "5px" }}
          ></img>
        </a>
        <a href={this.state.facebookUrl}>
          <img
            src="\images\icon_facebook.png"
            width="30px"
            height="30px"
            className="d-inline-block "
            alt="Facebook"
            style={{ margin: "5px" }}
          ></img>
        </a>
      </div>
    );
  }

  getLogo = () => {
    var self = this;
    firebase
      .database()
      .ref("/Logo/")
      .on("value", function(snapshot) {
        // console.log(snapshot.val());
        self.setState({ logoUrl: snapshot.val().logoPhotoPath });
        self.setState({ logoName: snapshot.val().logoName });
        self.setState({ facebookUrl: snapshot.val().facebookUrl });
        self.setState({ instagramUrl: snapshot.val().instagramUrl });
      });
  };
}

export default Footer;
